import {
  CATEGORY_DATA,
  CREATE_CATEGORY_LOADER,
  CREATE_SUB_CATEGORY_LOADER,
  DELETE_CATEGORY_LOADER,
  GET_ALL_CATEGORIES,
  GET_CATEGORIES_POST,
  GET_CATEGORIES_POST_LOADER,
  SUB_CATEGORY_DATA,
  UPDATE_CATEGORY_LOADER,
  UPDATE_SUB_CATEGORY_LOADER,
} from '../action/Category';

const initialState = {
  createCategoryLoader: false,
  createSubCategoryLoader: false,
  CategoryData: false,
  subCategoryData: false,
  updateSubCategoryLoader: false,
  updateCategoryLoader: false,
  deleteCategoryLoader: false,
  getCategoriesPostLoader: false,
  getCategoriesPostData: false,
  allCategoriesOfBook: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORIES:
      return {
        ...state,
        allCategoriesOfBook: action.payload,
      };
    case CREATE_CATEGORY_LOADER:
      return {
        ...state,
        createCategoryLoader: action.payload,
      };
    case CATEGORY_DATA:
      return {
        ...state,
        CategoryData: action.payload,
      };
    case SUB_CATEGORY_DATA:
      return {
        ...state,
        subCategoryData: action.payload,
      };
    case UPDATE_SUB_CATEGORY_LOADER:
      return {
        ...state,
        updateSubCategoryLoader: action.payload,
      };
    case CREATE_SUB_CATEGORY_LOADER:
      return {
        ...state,
        createSubCategoryLoader: action.payload,
      };

    case UPDATE_CATEGORY_LOADER:
      return {
        ...state,
        updateCategoryLoader: action.payload,
      };
    case DELETE_CATEGORY_LOADER:
      return {
        ...state,
        deleteCategoryLoader: action.payload,
      };
    case GET_CATEGORIES_POST_LOADER:
      return {
        ...state,
        getCategoriesPostLoader: action.payload,
      };

    case GET_CATEGORIES_POST:
      return {
        ...state,
        getCategoriesPostData: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
